<dx-select-box
    class="pictured-item-select-box"
    [label]="label"
    [value]="value"
    (valueChange)="valueChange.emit($event)"
    [dataSource]="dataSource"
    [showClearButton]=true
    [searchEnabled]="true"
    [searchMode]="'contains'"
    valueExpr="id"
    displayExpr="name"
    stylingMode="filled"
    width="100%"
    fieldTemplate="field"
    [dropDownOptions]="{
        wrapperAttr: { class: 'pictured-item-select-box-dropdown' }
    }"
    [readOnly]="readOnly"
>
    <dx-validator [validationRules]="validators"></dx-validator>

    <div *dxTemplate="let data of 'field'" class="pictured-item-select-field">
        @if (getData(data)?.avatarUrl) {
            <img
                [alt]="getData(data)?.name"
                class="pictured-item-image"
                [height]="20"
                [width]="20"
                [ngSrc]="getData(data).avatarUrl"
            />
        }
        <dx-text-box
            [hoverStateEnabled]="false"
            [inputAttr]="{ class: 'pictured-item-editor-input' }"
            [readOnly]="readOnly"
            [value]="getData(data)?.name"
        >
        </dx-text-box>
    </div>
    <div *dxTemplate="let data of 'item'">
        @if (getData(data)?.avatarUrl) {
            <img
                [alt]="getData(data).name"
                class="pictured-item-image"
                [height]="20"
                [width]="20"
                ngSrc="{{ getData(data).avatarUrl }}"
            />
        }
        {{ getData(data)?.name }}
    </div>
</dx-select-box>
